/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var $:any;
@Component({
  templateUrl:'./challengeTaskEdit.html'
})

export class ChallengeTaskEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService
  ){}

  private data:any={
    "endTime": "",
    "startTime": "",
    "type": ""
  }

  private id:number = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.initTime();
    this.route.params.subscribe((params) => {
      this.id=params['type'];
      if(this.id!=0){
        this.getData();
      }else {
        this.isCreate = true;
      }
    });


  }

  private initTime(){
    setTimeout(res=>{
      $("#startTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,
        startDate:this.common.dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss'),
      }).on('changeDate', function(ev){
        $("#endTime").datetimepicker('setStartDate',$("#startTime").val());
      });

      $("#endTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,
        startDate:this.common.dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss'),
      }).on('changeDate', function(ev){
        $("#startTime").datetimepicker('setEndDate',$("#endTime").val());
      });
    })

  }



  private getData():void{
    this.HttpService.getData(API.challenge_push+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }

  private submit():void{
    this.HttpService.postData(API.challenge_push,{
      "endTime":$('#endTime').val(),
      "startTime":$('#startTime').val(),
      "type": this.data.type
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

  //删除时间值
  private removeStartTime(){
    $('#startTime').val('');
  }
  private removeEndTimeDetil(){
    $('#endTime').val('');
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/challengeTaskEdit.component.ts